const statements = [
  {
    title: 'Senior-led review',
    body: 'Architecture and code decisions are made and reviewed by experienced engineers — not delegated to junior staff or unchecked automation.',
  },
  {
    title: 'No black-box handoff',
    body: 'You receive source access, deployment runbooks, and direct knowledge transfer. We build systems your team can operate and extend.',
  },
  {
    title: 'Documentation in scope',
    body: 'Technical documentation, API references, and operational guides are part of delivery — not an optional add-on at the end.',
  },
  {
    title: 'NDA-covered delivery',
    body: 'Client work, architecture, and engagement details remain confidential. Representative case studies are anonymized by default.',
  },
  {
    title: 'Production standards',
    body: 'Security baselines, observability, and deployment pipelines are built into the scope from the first sprint — not promised for a later phase.',
  },
]

/** Marginal notes — headings carry their own weight; no kickers. */
export function Authority() {
  return (
    <section id="authority" className="bg-sheet">
      <div className="mx-auto max-w-[100rem] px-6 py-12 lg:px-8 lg:py-16">
        <div className="grid gap-8 lg:grid-cols-[18rem_1fr] lg:gap-14">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <h2 className="section-title text-ink">Why Passwork</h2>
            <p className="mt-4 text-sm leading-relaxed text-ink-muted">
              What separates a disciplined engineering partner from a vendor that
              disappears after launch.
            </p>
          </div>

          <dl className="divide-y divide-rule border-y border-rule">
            {statements.map((item) => (
              <div key={item.title} className="py-5">
                <dt>
                  <h3 className="entry-title text-ink">{item.title}</h3>
                </dt>
                <dd className="mt-2 max-w-2xl text-[0.9375rem] leading-relaxed text-ink-muted">
                  {item.body}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  )
}
